import React from 'react';
import QawaemTableCheckbox from './QawaemTableCheckbox';
import { mergeStickySelectClass } from './QawaemTableStickyActions';

/** Sticky bulk-select header cell — matches المتغيرات / وحدات القياس tables. */
export function QawaemTableSelectAllHeader({
  allRowsSelected,
  someRowsSelected,
  onChange,
  selectAllTitle = 'Select all',
  deselectAllTitle = 'Deselect all',
}) {
  return (
    <th
      className={mergeStickySelectClass('px-3 py-3 text-center align-middle')}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex justify-center">
        <QawaemTableCheckbox
          size="lg"
          checked={allRowsSelected}
          indeterminate={someRowsSelected}
          onChange={onChange}
          title={allRowsSelected ? deselectAllTitle : selectAllTitle}
        />
      </div>
    </th>
  );
}

/** Sticky bulk-select body cell — separated column with vertical divider styling. */
export function QawaemTableSelectRowCell({ checked, onChange, dataLabel }) {
  return (
    <td
      className={mergeStickySelectClass('px-3 py-4 text-center align-middle')}
      data-label={dataLabel}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex justify-center">
        <QawaemTableCheckbox checked={checked} onChange={onChange} />
      </div>
    </td>
  );
}

/** Row selection helpers for filtered ERP list tables. */
export function useQawaemFilteredRowSelection(filteredItems, getId = (item) => item.id) {
  const [selectedRecords, setSelectedRecords] = React.useState([]);
  const filteredIds = React.useMemo(
    () => filteredItems.map(getId),
    [filteredItems, getId],
  );
  const allRowsSelected =
    filteredIds.length > 0 && filteredIds.every((id) => selectedRecords.includes(id));
  const someRowsSelected = selectedRecords.length > 0 && !allRowsSelected;

  const handleSelectAll = React.useCallback(() => {
    if (allRowsSelected || someRowsSelected) {
      setSelectedRecords([]);
    } else {
      setSelectedRecords(filteredIds);
    }
  }, [allRowsSelected, someRowsSelected, filteredIds]);

  const handleSelectRecord = React.useCallback((id) => {
    setSelectedRecords((prev) =>
      prev.includes(id) ? prev.filter((rId) => rId !== id) : [...prev, id],
    );
  }, []);

  const clearSelection = React.useCallback(() => setSelectedRecords([]), []);

  return {
    selectedRecords,
    setSelectedRecords,
    allRowsSelected,
    someRowsSelected,
    handleSelectAll,
    handleSelectRecord,
    clearSelection,
  };
}
